import { render, staticRenderFns } from "./CustomerEntityAdd.vue?vue&type=template&id=2cd787f2"
import script from "./CustomerEntityAdd.vue?vue&type=script&lang=js"
export * from "./CustomerEntityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports